/**
 * Prefix of content types
 */
// eslint-disable-next-line etc/no-const-enum
export enum CompatibleContentTypePrefix {

    /**
     * Text type prefix
     */
    Text = 'text/',

    /**
     * Image type prefix
     */
    Image = 'image/',
}

/**
 * Known content types
 */
// eslint-disable-next-line etc/no-const-enum
export enum CompatibleContentType {

    /**
     * Plain text content type
     */
    PlainText = 'text/plain',

    /**
     * HTML content type
     */
    HTML = 'text/html',
}
